import { useState, useEffect } from 'react';
import { Typography, Box } from '@mui/material';
import { GoogleMap, useLoadScript, MarkerF, InfoWindow } from '@react-google-maps/api';
import { mapContainerStyle, options } from '../../models/MapConfig';
import { facility } from '../../models/DashboardInformation';
import localConfig from '../../config';
interface FacilityInformationProps {
  data: facility | null;
}

const MapView: React.FC<FacilityInformationProps> = ({ data }) => {
  // Call hooks unconditionally
  const [isMounted, setIsMounted] = useState(false);
  const [isInfoWindowOpen, setIsInfoWindowOpen] = useState(false); // Track InfoWindow visibility
  const apiKey = localConfig.googleMapKey || '';
  const { isLoaded, loadError } = useLoadScript({
    googleMapsApiKey: apiKey,
  });
  useEffect(() => {
    setIsMounted(true);
  }, []);
  // Ensure data and necessary properties are handled after hooks
  const latitude = data?.latitude || 0;
  const longitude = data?.longitude || 0;
  const landmarkLocation = {
    lat: latitude,
    lng: longitude,
  };
  if (loadError) return <div>Error loading map</div>;
  if (!isLoaded) return <div>Loading Map...</div>;
  return (
    <>
      {data ? (
        <Box p={2} border={'1px solid #000'} borderColor={'divider'} height={'100%'}>
          <Typography mb={1} variant="h3" color="text.secondary">Map View</Typography>
          <Box>
            <GoogleMap
              mapContainerStyle={mapContainerStyle}
              zoom={14}
              center={landmarkLocation}
              options={options}

            >
              {isMounted && (
                <>
                  <div
                    onMouseOver={() => setIsInfoWindowOpen(true)}
                    onMouseOut={() => setIsInfoWindowOpen(false)}
                  >
                    <MarkerF position={landmarkLocation}>
                      {isInfoWindowOpen && (
                        <InfoWindow position={landmarkLocation} onCloseClick={() => setIsInfoWindowOpen(false)}>
                          <div>
                            <Typography variant="body2">
                              {data.address}
                            </Typography>
                          </div>
                        </InfoWindow>
                      )}
                    </MarkerF>
                  </div>
                </>
              )}
            </GoogleMap>
          </Box>
        </Box>) : (
        <div>
        </div>
      )}
    </>
  );
};
export default MapView;
